import { useSelector } from 'react-redux';
import { RootState } from '../configureStore';
import useWindowDimensions from './useWindowDimensions';

export default function useIsMobile(): boolean {
    const reduxIsMobile = useSelector<RootState, boolean>(({ status: { isMobile: im } }) => im || false);
    const { height, width } = useWindowDimensions();
    return reduxIsMobile || (height <= 500 && width <= 1000);
}
